import { environment } from '../../environments/environment';

import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const apis = [environment.subscriptionApiUrl, environment.retailApiUrl, environment.inventoryApiUrl];
    const target = new URL(req.url, window.location.origin);
    const isApi = apis.some(base => {
      const api = new URL(base);
      return target.origin === api.origin && (target.pathname === api.pathname.replace(/\/$/, '') ||
        target.pathname.startsWith(api.pathname.replace(/\/$/, '') + '/'));
    });
    if (!isApi) return next.handle(req);
    let authToken: string | null = "";
    
    authToken = this.authService.token; // Get the token from your auth service
   
    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    const authReq = authToken ? req.clone({
      headers: req.headers.set('Authorization', `Bearer ${authToken}`)
    }) : req;

    // send cloned request with header to the next handler.
    return next.handle(authReq)
      .pipe(
        catchError((error: HttpErrorResponse) => {

          if (error.status === 401) {
              this.authService.clearStaffAccess();
              this.authService.initCodeFlow();
          }
          if (error.status === 403) this.authService.clearStaffAccess();
          return throwError(() => error);
        })
      );
  }
}